import { storeToRefs } from 'pinia'
import { computed, unref } from 'vue'

import { useAuthStore } from '~/stores/auth'

export function useProductBadges(tagsSource, options = {}) {
  const {
    price: priceSource = null,
    additionalCodes = null,
  } = options

  const authStore = useAuthStore()
  const { settings } = storeToRefs(authStore)

  const priceBadgeCode = computed(() => {
    const price = unref(priceSource)
    const action = price?.action
    if (!action) {
      return null
    }
    return 'OFFER'
  })

  const badges = computed(() => {
    const tags = unref(tagsSource)
    const availableBadges = settings.value?.badges

    if (!availableBadges) {
      return []
    }

    const seen = new Set()

    const resolvedAdditionalCodes = unref(additionalCodes)

    const inputs = []

    if (Array.isArray(tags)) {
      inputs.push(...tags)
    }
    else if (tags) {
      inputs.push(tags)
    }

    if (Array.isArray(resolvedAdditionalCodes)) {
      inputs.push(...resolvedAdditionalCodes)
    }
    else if (resolvedAdditionalCodes) {
      inputs.push(resolvedAdditionalCodes)
    }

    const actionCode = priceBadgeCode.value

    if (actionCode) {
      inputs.push(actionCode)
    }

    if (!inputs.length) {
      return []
    }

    return inputs
      .map((tag) => {
        const code = tag?.code ?? tag

        if (!code || seen.has(code)) {
          return null
        }

        seen.add(code)

        const badge = availableBadges[code]

        if (!badge) {
          return null
        }

        return {
          ...badge,
          code,
        }
      })
      .filter(Boolean)
      .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
  })

  return {
    badges,
  }
}
